import * as React from 'react';
import clsx from 'clsx';

import { InputInviteUser } from 'src/models/team.model';
import { P4 } from 'src/components/Typography';
import { CloseButton } from 'src/components/Button';
import { ID } from 'src/models';
import RoleDropdown from '../RoleDropdown';
import { ResourceData } from 'src/models/modal.model';

import classes from './InviteUser.module.scss';

interface Props {
  user: InputInviteUser;
  onChange: (user: InputInviteUser) => void;
  onDelete: () => void;
  resource: ResourceData;
}

export function InviteUser({ user, onChange, onDelete, resource }: Props) {
  const { email } = user;

  function handleOnChange(role_id: ID, role_name: string) {
    onChange({ ...user, role_id, role_name });
  }

  return (
    <div className={clsx(classes.container, 'row a-center items-p8 w-100p')}>
      <P4 className='f-1'>{email}</P4>
      <RoleDropdown value={user.role_id} name={user.role_name} resource={resource} onChange={handleOnChange} />
      <CloseButton onClick={onDelete} />
    </div>
  );
}
